import {useEffect,useState} from 'react';
import { useNavigate ,useParams} from "react-router-dom";

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from "@mui/material";
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import AddIcon from '@mui/icons-material/Add';
import UploadIcon from '@mui/icons-material/Upload';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
//import FormControl from '@mui/material/FormControl';
//import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
//import Box from '@mui/material/Box';


import TopPrivateNavigation from '../components/TopPrivateNavigation.jsx'
import AppLogout from '../components/AppLogout.jsx'

//services
import AuthService from '../service/auth'
import FoodService from '../service/Food'
import ProjectService from '../service/Project'

const formatJson=function(obj){
	return JSON.stringify(obj);
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


const Foods = () => {
	
	//let params = useParams();
	let project_id =ProjectService.getCurrentProject();//params.id;
	//console.log('project_id',project_id);
	
	const navigate = useNavigate();
	//protected page check if logged in
	const [currentUser,setCurrentUser]=useState({});
	const [projectData,setProjectData]=useState([]);
	const [projectFound,setProjectFound]=useState(false);
	
	const [FoodData,setFoodData]=useState([]);
	const [LocalFoodData,setLocalFoodData]=useState([]);
	const [GlobalFoodData,setGlobalFoodData]=useState([]);
	
	const [FoodDataLoaded,setFoodDataLoaded]=useState(false);
	const [GlobalFoodDataLoaded,setGlobalFoodDataLoaded]=useState(false);
	const [LocalFoodDataLoaded,setLocalFoodDataLoaded]=useState(false);

	//tabs
	const [value, setValue] = useState(0);

	  const handleChange = (event, newValue) => {
		setValue(newValue);
	  };
	
	/*function loadFoodData(){
		FoodService.getAll().then(function(res){
			setFoodData(res.data);
			setFoodDataLoaded(true);
			console.log(res.data);
			console.log('FoodDataLoaded',FoodDataLoaded);
			console.log(res.data);
		});
	}*/
	
	function loadAllFood(){
		FoodService.getAll().then(function(res){
			setFoodData(res.data);
			setFoodDataLoaded(true);
			setFilteredFoodData(res.data);
			console.log(res.data);
		});
	}
	
	function loadGlobalFood(filter){
		FoodService.getByFilter(filter).then(function(res){
			setGlobalFoodData(res.data);
			setGlobalFoodDataLoaded(true);
			setFilteredGlobalFoodData(res.data);
			console.log(res.data);
		});
	}
	
	function loadLocalFood(filter){
		FoodService.getByFilter(filter).then(function(res){
			setLocalFoodData(res.data);
			setLocalFoodDataLoaded(true);
			setFilteredLocalFoodData(res.data);
			console.log(res.data);
		});
	}
	
	const renderDetailsButton = (params) => {
        return (
            <strong>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ marginLeft: 0 }}
                    onClick={() => {
                        moreInfo(params.row)
                    }}
                >
                    More Info
                </Button>
            </strong>
        )
    }
	const renderCloneButton = (params) => {
        return (
            <strong>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ marginLeft: 0 }}
                    onClick={() => {
                        //cloneFood(params.row)
						navigate("/food/clone/"+params.row._id);
                    }}
                >
                   Clone
                </Button>
            </strong>
        )
    }
	const renderCopyToGlobalButton = (params) => {
        return (
            <strong>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ marginLeft: 0 }}
                    onClick={() => {
                        //cloneFood(params.row)
						//navigate("/food/copy/"+params.row._id);
                    }}
                >
                   Copy
                </Button>
            </strong>
        )
    }
	
	const renderCopyToProjectButton = (params) => {
        return (
            <strong>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ marginLeft: 0 }}
                    onClick={() => {
                        //cloneFood(params.row)
						navigate("/food/copy/"+params.row._id);
						//copyToProjectModal(params.row)
                    }}
                >
                   Copy to project
                </Button>
            </strong>
        )
    }
	
	const renderCopyButton = (params) => {
        return (
            <strong>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ marginLeft: 0 }}
                    onClick={() => {
                        //cloneFood(params.row)
						navigate("/food/copy/"+params.row._id);
						//copyToProjectModal(params.row)
                    }}
                >
                   Make Copy
                </Button>
            </strong>
        )
    }
	
	function copyToProjectModal(food){
		console.log('food:',food);
	}
	
	const renderCreater = (params) => {
        return (
            <strong>
			{(params.row.created_by!==null)?<>{params.row.created_by.first_name} {params.row.created_by.last_name} ({params.row.created_by.__t})</>:<>Unknown</>}
            </strong>
        )
    }
	
	
	const renderMasterApproved = (params) => {
        return (
		<strong>
			{params.row.approved ? 
			<>
			Yes
			</>:<>
			 <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ marginLeft: 0 }}
                    onClick={() => {
                        //cloneFood(params.row)
						navigate("/food/approve/"+params.row._id);
						//copyToProjectModal(params.row)
                    }}
                >
                   Approve
                </Button>
			</>}
		</strong>
        )
    }
	
	const renderResearcherApproved = (params) => {
        return (
		<strong>
		{params.row.approved ? 
			<>
			Yes
			</>:<>
			No
			</>}
		</strong>
        )
    }
	
	//global list of foods
	const columns = [
	  { field: 'code', headerName: 'CODE', width: 100 },
	  { field: 'name', headerName: 'Name', width: 400 },
	  { field: 'group', headerName: 'Food Group', width: 150 },
	//  { field: 'approved', headerName: 'Approved', width: 100 },
	 /*{
			field: '2',
			headerName: 'Created By',
			//width: 150,
			renderCell: renderCreater,
			disableClickEventBubbling: true,
		},*/
	 {
			field: '3',
			headerName: '',
			//width: 150,
			renderCell: renderDetailsButton,
			disableClickEventBubbling: true,
		}/*,{
			field: '4',
			headerName: '',
			width: 150,
			renderCell: renderCopyToProjectButton,
			disableClickEventBubbling: true,
		}*/
	];
	
	//project food list 
	const project_columns_master = [
	  { field: 'code', headerName: 'CODE', width: 100 },
	  { field: 'name', headerName: 'Name', width: 400 },
	  { field: 'group', headerName: 'Food Group', width: 150 },
	/*  { field: 'approved', headerName: 'Approved', width: 100 },*/
	 {
			field: '1',
			headerName: 'Approved',
			//width: 150,
			renderCell: renderMasterApproved,
			disableClickEventBubbling: true,
		}
	 ,
	 {
			field: '2',
			headerName: 'Created By',
			//width: 150,
			renderCell: renderCreater,
			disableClickEventBubbling: true,
		},
	 {
			field: '3',
			headerName: '',
			//width: 150,
			renderCell: renderDetailsButton,
			disableClickEventBubbling: true,
		},
	 {
			field: '4',
			headerName: '',
			//width: 150,
			renderCell: renderCopyButton,
			disableClickEventBubbling: true,
		}/*,{
			field: '4',
			headerName: '',
			//width: 150,
			renderCell: renderCopyToGlobalButton,
			disableClickEventBubbling: true,
		}*/
	];
	
		const project_columns_researcher = [
	  { field: 'code', headerName: 'CODE', width: 100 },
	  { field: 'name', headerName: 'Name', width: 400 },
	  { field: 'group', headerName: 'Food Group', width: 150 },
	 /* { field: 'approved', headerName: 'Approved', width: 100 },*/
	 {
			field: '1',
			headerName: 'Approved',
			//width: 150,
			renderCell: renderResearcherApproved,
			disableClickEventBubbling: true,
		},
	 {
			field: '2',
			headerName: 'Created By',
			//width: 150,
			renderCell: renderCreater,
			disableClickEventBubbling: true,
		},
	 {
			field: '3',
			headerName: '',
			//width: 150,
			renderCell: renderDetailsButton,
			disableClickEventBubbling: true,
		},
	 {
			field: '4',
			headerName: '',
			//width: 150,
			renderCell: renderCopyButton,
			disableClickEventBubbling: true,
		}/*,{
			field: '4',
			headerName: '',
			//width: 150,
			renderCell: renderCopyToGlobalButton,
			disableClickEventBubbling: true,
		}*/
	];
	
	//global foods list within project	
	const global_columns = [
	  { field: 'code', headerName: 'CODE', width: 100 },
	  { field: 'name', headerName: 'Name', width: 400 },
	  { field: 'group', headerName: 'Food Group', width: 150 },
	/*  { field: 'approved', headerName: 'Approved', width: 100 },*/
	 {
			field: '2',
			headerName: 'Created By',
			//width: 150,
			renderCell: renderCreater,
			disableClickEventBubbling: true,
		},
	 {
			field: '3',
			headerName: '',
			//width: 150,
			renderCell: renderDetailsButton,
			disableClickEventBubbling: true,
		},{
			field: '4',
			headerName: '',
			width: 150,
			renderCell: renderCopyToProjectButton,
			disableClickEventBubbling: true,
		}
	];

	const moreInfo = (item) => {
		console.log('food',item);
		navigate("/food/view/"+item._id);
	};
	
	useEffect(() => {
		if(!AuthService.isUserLoggedIn()){
			// not logged in navigate back to login
			navigate("/login");
		}else{
				setCurrentUser(AuthService.getCurrentUser());
				var account_type=AuthService.getCurrentUser().__t;
				console.log('account_type',account_type);
				
				console.log(AuthService.getCurrentUser());
				var currentUser=AuthService.getCurrentUser();
				//expired Account
				if(currentUser.expired){
					var string = "account_type="+AuthService.getCurrentUser().__t+"&type=expired";
					console.log('string',string);
					var encodedString = btoa(string); // Base64 encode the String
					console.log('encodedString',encodedString);
					navigate("/restricted/"+encodedString);
					
				}else{//unverified account
					if(!currentUser.email_verified){
						var string = "account_type="+AuthService.getCurrentUser().__t+"&type=emaiverification";
						console.log('string',string);
						var encodedString = btoa(string); // Base64 encode the String
						console.log('encodedString',encodedString);
						navigate("/restricted/"+encodedString);
						
					}else{////force change Password
						if(currentUser.force_password_change){
								
						
						}else{
							if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
								loadProjectById(project_id);
								//loadAllFood();
								loadGlobalFood({'global':true});
								loadLocalFood({'global':false,'project':project_id});
								
							}else{
								loadGlobalFood({'global':true});
							}
							
							
							//load
							/*if(account_type=='Admin'){//Admin
								//loadFoodData();
							}else if(account_type=='Master'){//Master
								//loadFoodData();
								
							}else if(account_type=='Researcher'){//Researcher
								//loadFoodData();
							}*/
						}
					}
				}	
		}
	}, []);
	
		function loadProjectById(project_id){
			ProjectService.getById(project_id).then(function(res){
				setProjectData(res.data);
				console.log(res.data);
				setProjectFound(true);
			}).catch(function(error){
					console.log(error);
					setProjectFound(false);
			});
		}
	
	const [FilteredFoodData,setFilteredFoodData]=useState([]);
	const handleFoodSearchChange = (event) => {
		setFilteredFoodData([]);
		var filteredList=[];
		console.log(event.target.value);
		var keyword =event.target.value
		if(keyword.length==0){	
			setFilteredFoodData(FoodData);
		}
		if(keyword.length>0){
			for(var i=0;i<FoodData.length;i++){
			//if(FoodData[i].name)
				if(FoodData[i].name.toLowerCase().includes(keyword.toLowerCase()) || FoodData[i].code.toLowerCase().includes(keyword.toLowerCase())){
					filteredList.push(FoodData[i]);
				}
		}
		setFilteredFoodData(filteredList);
			
		}
	}
	
	
	const [FilteredGlobalFoodData,setFilteredGlobalFoodData]=useState([]);
	const handleGlobalFoodSearchChange = (event) => {
		setFilteredGlobalFoodData([]);
		var filteredList=[];
		console.log(event.target.value);
		var keyword =event.target.value
		if(keyword.length==0){	
			setFilteredGlobalFoodData(GlobalFoodData);
		}
		if(keyword.length>0){
			for(var i=0;i<GlobalFoodData.length;i++){
			//if(GlobalFoodData[i].name)
				if(GlobalFoodData[i].name.toLowerCase().includes(keyword.toLowerCase()) || GlobalFoodData[i].code.toLowerCase().includes(keyword.toLowerCase())){
					filteredList.push(GlobalFoodData[i]);
				}
		}
		setFilteredGlobalFoodData(filteredList);
			
		}
	}
	
		const [FilteredLocalFoodData,setFilteredLocalFoodData]=useState([]);
	const handleLocalFoodSearchChange = (event) => {
		setFilteredLocalFoodData([]);
		var filteredList=[];
		console.log(event.target.value);
		var keyword =event.target.value
		if(keyword.length==0){	
			setFilteredLocalFoodData(LocalFoodData);
		}
		if(keyword.length>0){
			for(var i=0;i<LocalFoodData.length;i++){
			//if(LocalFoodData[i].name)
				if(LocalFoodData[i].name.toLowerCase().includes(keyword.toLowerCase()) || LocalFoodData[i].code.toLowerCase().includes(keyword.toLowerCase())){
					filteredList.push(LocalFoodData[i]);
				}
		}
		setFilteredLocalFoodData(filteredList);
			
		}
	}
	
  return(
  <>
	<TopPrivateNavigation/>
	<AppLogout>
	
<br/>
	{(projectFound) ?
	<>
	<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/"> Home </Link>
		<Link
          underline="hover"
          color="inherit"
          href="/projects"
        >
          Projects
        </Link>
		<Link
          underline="hover"
          color="inherit"
          href={`/project/${projectData._id}`}
        >
          {projectData.name}
        </Link>

		 <Link underline="hover" color="inherit" href={`/foods`} > Foods  </Link>
		{/*<Typography color="text.primary">test</Typography>*/}
      </Breadcrumbs>
	
	</>
	:<>
	<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/"> Home </Link>
		 <Link underline="hover" color="inherit" href="/foods" > Foods  </Link>
		{/*<Typography color="text.primary">test</Typography>*/}
      </Breadcrumbs>
	</>}
	
	  
	<br/>
	
	
	<Divider />
	<br/>
	
	{/* Master */}
	{(currentUser.__t=='Master') &&
	<>
		<div style={{ width: '100%' }}>
			<Box
				sx={{
				  display: 'flex',
				  justifyContent: 'space-between',
				  p: 1,
				  m: 1,
			  //    bgcolor: 'background.paper',
				  borderRadius: 1,
				}}
			>
			<Button href={`/food/new`}  variant="contained" endIcon={<AddIcon />} >
				Create New Food 
			</Button>
		
			<Button href={`/upload/food`}  variant="outlined" endIcon={<UploadIcon />} >
				Upload data
			</Button>

			</Box>
		</div>
	</>
	}
	{/* Researcher */}
	{(currentUser.__t=='Researcher') &&
	<>
		<div style={{ width: '100%' }}>
			<Box
				sx={{
				  display: 'flex',
				  justifyContent: 'space-between',
				  p: 1,
				  m: 1,
			  //    bgcolor: 'background.paper',
				  borderRadius: 1,
				}}
			>
			{(projectFound) &&
			<>
			<Button href={`/food/new`}  variant="contained" endIcon={<AddIcon />} >
				Request New Food 
			</Button>
			</>}

			</Box>
		</div>
	</>
	}
	
	{(projectFound) ?
	<>
	 <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
			{/*<Tab label="All" {...a11yProps(0)} />*/}
          <Tab label="Local" {...a11yProps(0)} />
          <Tab label="Global" {...a11yProps(1)} />
        </Tabs>
      </Box>
	  {/*  <CustomTabPanel value={value} index={0}>
        All
	</CustomTabPanel>*/}
      <CustomTabPanel value={value} index={0}>
        {(LocalFoodData.length>0) ?
				
			<div style={{ height: 800, width: '100%' }}>
			
			<TextField fullWidth onChange={(e) => {handleLocalFoodSearchChange(e)}}
				id="outlined-basic" 
				label="Search by name or code.." 
				variant="outlined"
				InputProps={{
					startAdornment: (
					<InputAdornment position="start">
						<SearchIcon />
					</InputAdornment>
					),
				}}	
			/>
			<br/><br/>
			{FilteredLocalFoodData.length} found.
			<br/><br/>
				{(currentUser.__t=='Master') &&
				<>
				<DataGrid
				rows={FilteredLocalFoodData}
				columns={project_columns_master}
				initialState={{
				  pagination: {
					paginationModel: { page: 0, pageSize: 15},
				  },
				}}
				pageSizeOptions={[5, 10,15,20]}
				checkboxSelection={false}
				/>
				
				
				
				</>}
				
				{(currentUser.__t=='Researcher') &&
				<>
				
				<DataGrid
				rows={FilteredLocalFoodData}
				columns={project_columns_researcher}
				initialState={{
				  pagination: {
					paginationModel: { page: 0, pageSize: 15},
				  },
				}}
				pageSizeOptions={[5, 10,15,20]}
				checkboxSelection={false}
				/>
				
				
				</>}
				
			
		</div>
			:<>None found!!!
			<br/>	
		</>}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {(GlobalFoodData.length>0) ?
				
			<div style={{ height: 800, width: '100%' }}>
			
			<TextField fullWidth onChange={(e) => {handleGlobalFoodSearchChange(e)}}
				id="outlined-basic" 
				label="Search by name or code.." 
				variant="outlined"
				InputProps={{
					startAdornment: (
					<InputAdornment position="start">
						<SearchIcon />
					</InputAdornment>
					),
				}}	
			/>
			<br/><br/>
			{FilteredGlobalFoodData.length} found.
			<br/><br/>

				<DataGrid
				rows={FilteredGlobalFoodData}
				columns={global_columns}
				initialState={{
				  pagination: {
					paginationModel: { page: 0, pageSize: 15},
				  },
				}}
				pageSizeOptions={[5, 10,15,20]}
				checkboxSelection={false}
				/>
			
		</div>
			:<>None found!!!
			<br/>	
		</>}
      </CustomTabPanel>
    </Box>
	</>:<>
	
	
	{(GlobalFoodDataLoaded) ?
	<>
		<br/>
		
		{(GlobalFoodData.length>0) ?
				
			<div style={{ height: 800, width: '100%' }}>
			
			<TextField fullWidth onChange={(e) => {handleGlobalFoodSearchChange(e)}}
				id="outlined-basic" 
				label="Search by name or code.." 
				variant="outlined"
				InputProps={{
					startAdornment: (
					<InputAdornment position="start">
						<SearchIcon />
					</InputAdornment>
					),
				}}	
			/>
			<br/><br/>
			{FilteredGlobalFoodData.length} found.
			<br/><br/>

				<DataGrid
				rows={FilteredGlobalFoodData}
				columns={columns}
				initialState={{
				  pagination: {
					paginationModel: { page: 0, pageSize: 15},
				  },
				}}
				pageSizeOptions={[5, 10,15,20]}
				checkboxSelection={false}
				/>
			
		</div>
			:<>None found!!!
			<br/>	
		</>}

	
	<br/> <br/><br/> <br/>
	</>
	:<>
	
	 <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
	
	
	</>}
	
	
	
	</>}
	{/* Admin */}
	{(currentUser.__t=='Admin') ?
	<>
	
	</>
	:<></>}
	
	{/* Master */}
		{/*{(currentUser.__t=='Master') ?
	<>
		<div style={{ width: '100%' }}>
			<Box
				sx={{
				  display: 'flex',
				  justifyContent: 'space-between',
				  p: 1,
				  m: 1,
			  //    bgcolor: 'background.paper',
				  borderRadius: 1,
				}}
			>
			<Button href={`/food/new`}  variant="contained" endIcon={<AddIcon />} >
				Create New Food 
			</Button>
		
			<Button href={`/upload/food`}  variant="outlined" endIcon={<UploadIcon />} >
				Upload data
			</Button>

			</Box>
		</div>
	<br/>
	{(FoodDataLoaded) ?
	<>
		<br/>
		
		{(FoodData.length>0) ?
				
			<div style={{ height: 800, width: '100%' }}>
			
			<TextField fullWidth onChange={(e) => {handleFoodSearchChange(e)}}
				id="outlined-basic" 
				label="Search by name or code.." 
				variant="outlined"
				InputProps={{
					startAdornment: (
					<InputAdornment position="start">
						<SearchIcon />
					</InputAdornment>
					),
				}}	
			/>
			<br/><br/>
			{FilteredFoodData.length} found.
			<br/><br/>
				
			{(projectFound) ?
			<>
				<DataGrid
				rows={FilteredFoodData}
				columns={project_columns}
				initialState={{
				  pagination: {
					paginationModel: { page: 0, pageSize: 15},
				  },
				}}
				pageSizeOptions={[5, 10,15,20]}
				checkboxSelection={false}
				
				/>
			
			</>:<>
			
				<DataGrid
				rows={FilteredFoodData}
				columns={global_columns}
				initialState={{
				  pagination: {
					paginationModel: { page: 0, pageSize: 15},
				  },
				}}
				pageSizeOptions={[5, 10,15,20]}
				checkboxSelection={false}
				/>
			
			</>}
			
			
		</div>
			:<>None found!!!
			
			<br/>
			
			
			</>}

	
	<br/> <br/><br/> <br/>
	</>
	:<>
	
	 <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
	
	
	</>}
	
	</>
		:<></>}*/}
	
	{/* Researcher */}
		{/*{(currentUser.__t=='Researcher') ?
	<>
	<br/>
	{(projectFound) &&
	<>
			<Button href={`/food/new`}  variant="contained" endIcon={<AddIcon />} >
				Request New Food 
			</Button>
			</>}

		<br/><br/>
		{(FoodDataLoaded) ?
		<>
		<br/>
		
		{(FoodData.length>0) ?
				
			<div style={{ height: 800, width: '100%' }}>
			
			<TextField fullWidth 
			onChange={(e) => {handleFoodSearchChange(e)}}
			id="outlined-basic" 
			label="Search by name or code.." 
			variant="outlined"
			InputProps={{
				startAdornment: (
				<InputAdornment position="start">
				<SearchIcon />
				</InputAdornment>
				),
					}}			
			
			/>
						<br/><br/>{FilteredFoodData.length} found.
						
						
						<br/><br/>
						
		  {(projectFound) ?
			<>
				<DataGrid
				rows={FilteredFoodData}
				columns={project_columns}
				initialState={{
				  pagination: {
					paginationModel: { page: 0, pageSize: 15},
				  },
				}}
				pageSizeOptions={[5, 10,15,20]}
				checkboxSelection={false}
				
				/>
			
			</>:<>
			
				<DataGrid
				rows={FilteredFoodData}
				columns={global_columns}
				initialState={{
				  pagination: {
					paginationModel: { page: 0, pageSize: 15},
				  },
				}}
				pageSizeOptions={[5, 10,15,20]}
				checkboxSelection={false}
				/>
			
			</>}
		  
		  
		</div>
			:<>None found!!!
			
			<br/>
			
			
			</>}

	
	<br/> <br/><br/> <br/>
	</>
	:<>
	
	 <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
	
	
	</>}
	
	</>
:<></>}*/}

	</AppLogout>
	</>
  ) 
  ;
};

export default Foods;